import { NotifyHelper } from "../../../helpers/toast";
import { ePhongUuTienBuoiActionsObj } from "../../action-types/category/IPhongUuTienBuoiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phongUuTienBuoiActions = {
    ...generateActions(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI"),
    ...generateActionForKey(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(ePhongUuTienBuoiActionsObj, "PHONG_UU_TIEN_BUOI", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
